<div class="background" (click)="closeFilter()" id="overlay"></div>
<div role="dialog" class="menu-content" [ngStyle]="objPosition" id="filter" #tableFilterServer aria-labelledby="dialog-title" aria-describedby="dialog-description">
  <div class="filter-search-content nr-form-fields-wrapper">
    <div class="nr-form-group">
      <input type="text" autocomplete="off" [formControl]="queryField" class="nr-form-control nr-search-control" placeholder="Search" id="email">
    </div>

    <div class="option-list-filter" >
      <div class="list-item">
        <mat-checkbox [checked]="isSelectedAll" class="nr-checkbox nr-checkbox-sm" (change)="selectDeselectAll($event)" [color]="'primary'">
          Select All
        </mat-checkbox>
      </div>
      <cdk-virtual-scroll-viewport [itemSize]="20" class="scroll-container"> 
        <div class="list-item" *cdkVirtualFor="let option of optionList;let i = index;trackBy:searchOptionList">
          <mat-checkbox [value]="option.name" [checked]="option.isSelected" [color]="'primary'" class="nr-checkbox nr-checkbox-sm" (change)="setSearchValue($event,i)">
            <ng-container>
              {{getOptionvalue(option)}}
            </ng-container>
           
          </mat-checkbox>
        </div>
      </cdk-virtual-scroll-viewport>
    
    </div>
    
    <div class="nr-button-section">
      <button class=" nr-button-sm" (click)="closeFilter()">Cancel</button>
      <button class=" nr-button-sm nr-button-primary" (click)="searchApply()">Filter</button>
    </div> 
  </div>
</div>
